define('home/templates/profileCommentsModulePost',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"post-comments\">\n<div class=\"spacing-bottom-narrow\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "#comment-"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.postActivity : depth0)) != null ? stack1.object : stack1)) != null ? stack1.id : stack1), depth0))
    + "\" class=\"link-gray-dark truncate\" data-truncate-lines=\"2\">\n"
    + alias2(alias1((depth0 != null ? depth0.message : depth0), depth0))
    + "\n</a>\n</div>\n<div class=\"link-gray text-gray text-small\">\n"
    + ((stack1 = container.invokePartial(partials.channelAwareForumLink,((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.forum : stack1),{"name":"channelAwareForumLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<time class=\"time\">"
    + alias2(alias1((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</time>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
